import React from 'react';
import { WrappedFieldProps } from 'redux-form';

import TextField from './TextField';

type Props = {
  input: string;
} & WrappedFieldProps;

const TextFieldWrapperForReduxForm = ({
  input,
  meta: { touched, error },
  ...restProps
}: Props) => (
  <TextField {...input} {...restProps} error={touched ? error : undefined} />
);

export default TextFieldWrapperForReduxForm;
